// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isCompanySettingsSubscriptionsAndUsageResult = objectOf({
  subscriptions_data: objectOf({
    email_max_type: string,
    data_point_max_type: string,
    allotted_data_points: number,
    contacts_upper_bound: number,
    monthly_active_users_mobile_upper_bound: number,
    monthly_unique_visitors_upper_bound: number,
    monthly_active_users_legacy_upper_bound: number,
    allotted_emails: number,
    contract_term_length: number,
    contract_payment_terms: string,
    current_contract_billing_start_date: string,
    current_contract_billing_end_date: string,
    current_contract_start_date: string,
    current_contract_end_date: string,
    has_salesforce_account: boolean,
  }),
  contract_start_date: number,
  mau_data: arrayOf(
    objectOf({
      date: number,
      monthly_active_users: number,
    })
  ),
  email_data: arrayOf(
    objectOf({
      date: number,
      total_usage: number,
      send_usage: number,
      test_send_usage: number,
      bcc_send_usage: number,
      seed_send_uasge: number,
    })
  ),
  email_data_by_app_group: arrayOf(
    objectOf({
      app_group_id: string,
      app_group_name: string,
      usage_data: arrayOf(
        objectOf({
          date: number,
          total_usage: number,
          send_usage: number,
          test_send_usage: number,
          bcc_send_usage: number,
          seed_send_uasge: number,
        })
      ),
    })
  ),
  email_contract_total: number,
  email_contract_total_by_app_group: arrayOf(
    objectOf({
      app_group_id: string,
      app_group_name: string,
      total_usage: number,
      send_usage: number,
      test_send_usage: number,
      bcc_send_usage: number,
      seed_send_uasge: number,
    })
  ),
  contract_range: string,
});
